import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';
import { UserFacade } from '@app/store/user';
import { filter, map } from 'rxjs';

export const initialize = (): RedirectFunction => {
    return () => {
        const router = inject(Router);
        const userFacade = inject(UserFacade);

        userFacade.clear();
        userFacade.getUser();

        return userFacade.loaded$.pipe(
            filter((loaded) => loaded !== null),
            map((loaded) => {
                return loaded === true ? router.createUrlTree(['/', 'dashboard']) : router.createUrlTree(['/', 'auth']);
            }),
        );
    };
};
